import { makeAutoObservable, runInAction } from "mobx";
import API from "../modules/api/CustomDictionaries";

export interface ICustomDictionaryModel {
  id: number | null;
  name: string | null;
  title: string | null;
  orderNum: number | null;
  parentId: number | null;
  isSystem: false;
  created: "0001-01-01T00:00:00";
  modified: null;
}

class CustomDictionariesStore {
  groups = [];
  dictionariesGroupped = [];
  panels = [];
  searhInput = "";
  isCreateDictionaryModalVisible = false;
  isHistoryModalVisible = false;
  groupName = "";
  dictionaryTitle = "";
  dictionaryName = "";
  tree = [];
  currentPage = 1;
  countPerPage = 25;
  isLoading = false;
  totalCount = null;
  expandedKeys = [];
  autoExpandParent = true;
  isSearchReset = false;
  itemsTotal = 0;

  constructor() {
    makeAutoObservable(this);
  }

  getDictionaryGroupsTree(
    isSearchValueChanged = false,
    isCountPerPageChanged = false,
  ) {
    if (isSearchValueChanged || isCountPerPageChanged || this.isSearchReset) {
      this.currentPage = 1;
      this.isSearchReset = false;
    }

    API.getDictionaryGroupsTree(
      this.currentPage,
      this.countPerPage,
      this.searhInput,
    )
      .then((response) => {
        if (response) {
          runInAction(() => {
            if (response.data.ItemsTotal > this.countPerPage) {
              this.totalCount = response.data.ItemsTotal / this.countPerPage;
            } else {
              this.totalCount = null;
            }
            this.itemsTotal = response.data.ItemsTotal
            this.tree = response.data.Items;
            this.isLoading = false;
            if (this.searhInput) {
              this.expandedKeys = [];
              this.expandedKeys = this.setTreeExpandedState(
                response.data.Items,
                [],
              );
              this.autoExpandParent = true;
            } else {
              this.expandedKeys = [];
            }
          });
        } else {
          alert("Ошибка загрузки данных!");
        }
      })
      .catch((error) => {
        alert(error.message);
      });
  }

  setTreeExpandedState(data, currentKeys) {
    const newExpandedKeys: string[] = currentKeys;
    data.forEach((item) => {
      newExpandedKeys.push(item.key);
      if (item.children)
        this.setTreeExpandedState(item.children, newExpandedKeys);
    });

    return newExpandedKeys;
  }

  setCountPerPage(count) {
    this.countPerPage = count;
  }

  setCurrentPage(pageNumber) {
    this.currentPage = pageNumber + 1;
  }

  setSearhInput(value) {
    this.searhInput = value;
  }

  setIsSearchReset(value) {
    this.isSearchReset = value;
  }

  getCustomDictionariesGroupped() {
    return API.getCustomDictionariesGroupped().then((res) => {
      runInAction(() => {
        this.dictionariesGroupped = res.data;
        this.panels = this.dictionariesGroupped?.map(
          (option) => option.groupTitle,
        );
      });
    });
  }

  getCustomDictionaryItems(dictionaryName) {
    return API.getCustomDictionaryItems(dictionaryName);
  }

  createDictionary() {
    return API.createDictionary({
      title: this.dictionaryTitle,
      id: 0,
      name: this.alphaNumericTransliter(this.dictionaryTitle),
      orderNum: null,
      parentId: null,
      isSystem: false,
      created: "0001-01-01T00:00:00",
      modified: null,
    });
  }

  addDictionaryToGroup() {
    return API.addDictionaryToGroup(
      this.groupName,
      this.alphaNumericTransliter(this.dictionaryTitle),
    );
  }

  updateCustomDictionaryItems(model) {
    return API.updateCustomDictionaryItems(model);
  }

  createCustomDictionaryItemsmodel(model) {
    return API.createCustomDictionaryItems(model);
  }

  getCustomDictionaryByName(model) {
    return API.getCustomDictionaryByName(model);
  }

  getAllItemsVersions(dictionaryName) {
    return API.getAllItemsVersions(dictionaryName);
  }

  alphaNumericTransliter = (word) => {
    let answer = "";
    const converter = {
      а: "a",
      б: "b",
      в: "v",
      г: "g",
      д: "d",
      е: "e",
      ё: "e",
      ж: "zh",
      з: "z",
      и: "i",
      й: "y",
      к: "k",
      л: "l",
      м: "m",
      н: "n",
      о: "o",
      п: "p",
      р: "r",
      с: "s",
      т: "t",
      у: "u",
      ф: "f",
      х: "h",
      ц: "c",
      ч: "ch",
      ш: "sh",
      щ: "sch",
      ь: "",
      ы: "y",
      ъ: "",
      э: "e",
      ю: "yu",
      я: "ya",

      А: "A",
      Б: "B",
      В: "V",
      Г: "G",
      Д: "D",
      Е: "E",
      Ё: "E",
      Ж: "Zh",
      З: "Z",
      И: "I",
      Й: "Y",
      К: "K",
      Л: "L",
      М: "M",
      Н: "N",
      О: "O",
      П: "P",
      Р: "R",
      С: "S",
      Т: "T",
      У: "U",
      Ф: "F",
      Х: "H",
      Ц: "C",
      Ч: "Ch",
      Ш: "Sh",
      Щ: "Sch",
      Ь: "",
      Ы: "Y",
      Ъ: "",
      Э: "E",
      Ю: "Yu",
      Я: "Ya",
    };

    for (let i = 0; i < word.length; ++i) {
      if (converter[word[i]] == undefined) {
        answer += word[i];
      } else {
        answer += converter[word[i]];
      }
    }

    return answer.replace(/\W/g, "");
  };
}

export default new CustomDictionariesStore();

// key должен быть уникальным у всех узлов

const mockData = {
  data: {
    totalCount: 200,
    items: [
      {
        key: "1",
        name: "DictionaryNull-10",
        title: "Справочник без группы 1",
        orderNum: null,
        parentId: null,
        isSystem: false,
        created: "2022-07-13T16:02:12.649874",
        modified: null,
      },
      {
        key: "2",
        name: "DictionaryNull-20",
        title: "Справочник без группы 2",
        orderNum: null,
        parentId: null,
        isSystem: false,
        created: "2022-07-13T16:02:19.233426",
        modified: null,
      },
      {
        key: "3",
        title: "Группа 1",
        level: 1,
        isLeaf: false,
        children: [
          {
            key: "4",
            name: "DictionaryNull-10",
            title: "Справочник Группы 1",
            orderNum: null,
            parentId: null,
            isSystem: false,
            created: "2022-07-13T16:02:12.649874",
            modified: null,
          },
          {
            key: "5",
            name: "DictionaryNull-10",
            title: "Подгруппа 1 группы 1",
            orderNum: null,
            parentId: null,
            isSystem: false,
            created: "2022-07-13T16:02:12.649874",
            modified: null,
            children: [
              {
                key: "6",
                name: "DictionaryNull-10",
                title: "Справочник 1 подгруппы 1 группы 1",
                orderNum: null,
                parentId: null,
                isSystem: false,
                created: "2022-07-13T16:02:12.649874",
                modified: null,
              },
              {
                key: "7",
                name: "DictionaryNull-10",
                title: "Справочник 2 подгруппы 1 группы 1",
                orderNum: null,
                parentId: null,
                isSystem: false,
                created: "2022-07-13T16:02:12.649874",
                modified: null,
              },
            ],
          },
        ],
      },
      {
        key: "11",
        title: "Группа 2",
        level: 1,
        isLeaf: false,
        children: [
          {
            key: "12",
            name: "DictionaryNull-10",
            title: "Справочник Группы 2",
            orderNum: null,
            parentId: null,
            isSystem: false,
            created: "2022-07-13T16:02:12.649874",
            modified: null,
          },
          {
            key: "13",
            name: "DictionaryNull-10",
            title: "Подгруппа 1 группы 2",
            orderNum: null,
            parentId: null,
            isSystem: false,
            created: "2022-07-13T16:02:12.649874",
            modified: null,
            children: [
              {
                key: "14",
                name: "DictionaryNull-10",
                title: "Справочник подгруппы 1 группы 2",
                orderNum: null,
                parentId: null,
                isSystem: false,
                created: "2022-07-13T16:02:12.649874",
                modified: null,
              },
            ],
          },
          {
            key: "15",
            name: "DictionaryNull-10",
            title: "Подгруппа 2 группы 2",
            orderNum: null,
            parentId: null,
            isSystem: false,
            created: "2022-07-13T16:02:12.649874",
            modified: null,
            children: [
              {
                key: "16",
                name: "DictionaryNull-10",
                title: "Справочник подгруппы 2 группы 2",
                orderNum: null,
                parentId: null,
                isSystem: false,
                created: "2022-07-13T16:02:12.649874",
                modified: null,
              },
            ],
          },
        ],
      },
    ],
  },
};
